module.exports = __webpack_public_path__ + "img/plane-up.0b9640a6.svg";